import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
    hideMessage,
    showAuthLoader,
    userFacebookSignIn,
    userGithubSignIn,
    userGoogleSignIn,
    userSignIn,
    userTwitterSignIn
} from 'actions/Auth';

import {
    BrowserView,
    MobileView,
    TabletView,
    isBrowser,
    isMobile
} from 'react-device-detect';

import {
    reqAllUserManage,
} from 'actions/UserManage';
import CarouselImage from './CarouselImage';

import { BASE_URL_API, HOSTNAME_OSLOG, BASE_URL_OSLOG } from "constants/ActionTypes";

class SignIn extends React.Component {
    constructor() {
        super();
        this.state = {
            // email: 'demo@example.com',
            // password: 'demo#123',
            email: '',
            password: ''
        }
    }

    componentDidMount() {
        // document.getElementById("myAudio").play();
        // console.log(window.location)
    }

    componentDidUpdate() {
        if (this.props.showMessage) {
            setTimeout(() => {
                this.props.hideMessage();
            }, 100);
        }
        if (this.props.authUser !== null) {
            // this.props.history.push('/');
            // // console.log('ok signin')

            // window.location = window.location.origin;
            // if (window.location.hostname === HOSTNAME_OSLOG) {
            //     //oslog
            //     window.location = BASE_URL_OSLOG + "/v5/";
            //     //advotics
            //     // window.location = BASE_URL_OSLOG + "/advotics/";
            // } else {
            //     window.location = window.location.origin;
            // }
            
            window.location = window.location.origin;

            // if(window.location.hostname === HOSTNAME_OSLOG){
            //     window.location = BASE_URL_OSLOG+"/v5/";
            // } else if(window.location.hostname === '202.47.70.196'){
            //     window.location = "http://202.47.70.196/epoool/";
            // } else if(window.location.hostname === 'linstasarta.oslog.id'){
            //     window.location = "http://linstasarta.oslog.id/";
            // } else {
            //     window.location = "http://localhost:4000/";
            // }
        }
    }

    render() {
        const {
            email,
            password
        } = this.state;
        const { showMessage, loader, alertMessage } = this.props;

        const body = document.body,
            html = document.documentElement;
        const width = Math.max(body.scrollwidth, body.offsetwidth,
            html.clientwidth, html.scrollwidth, html.offsetwidth);
        const height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);

        return (

            <div className="app-login-container animated slideInUpTiny animation-duration-3">
                {/* <div>
                    <iframe src={BASE_URL_API+"/audio/audio.mp3?apikey=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6NjMwLCJOYW1lIjoidGVzdGVyIiwiUm9sZSI6InRlc3RlciIsIkNvbXBhbnkiOjMyMywiZXhwIjoxNTYxMjg3MDcxLCJpc3MiOiJPU0xPRyA1IEFQSSJ9.tSjFsJVHFxgM50-ebEADUCSxjPYqOU2VrngjwJKILhE"} allow="autoplay" id="audio" style={{display: "none"}}></iframe>
                </div> */}
                {/* <video className="bg-video" autoplay muted loop>
                    <source src="assets/video/VID-20190807-WA0012.mp4" type="video/mp4" />
                </video> */}

                <div className="row">
                    {/* <div className="col-md-8"> */}
                    <div className="col-md-8" style={{ backgroundColor: "#dddddd" }}>
                        <div id="side-login" style={{ width: '100%', height: '100%' }}>
                            <CarouselImage />
                        </div>
                    </div>

                    <div className="col-md-4">
                        {/* <div className="col-md-4" style={{backgroundColor: "white"}}> */}
                        {/* <div className="col-md-4" style={{ backgroundColor: "#dddddd" }}> */}

                        {/* Default */}
                        <div className="content-login">

                            {/* sistelindo */}
                            {/* <div className="content-login mt-4"> */}
                            <div className="d-flex justify-content-center align-items-center">
                                {/* <img src="assets/images/oslog2.png" height="40px" width="250px" /> */}
                                {/* <img src="assets/images/advo_square.png" height="100px" width="250px" /> */}
                                {/*<img src="assets/images/ciputra2.png" height="60px" width="250px" />*/}
                                {/* <img src="assets/images/pinslogo.png" height="110px" width="270px"/> */}
                                {/* <img src="assets/images/sucofindo.png" height="80px" width="300px"/> */}
                                {/* <img src="assets/images/Lintasarta.png" height="100px" width="250px"/> */}
                                {/* <img src="assets/images/logoepoool.png" height="80px" width="250px"/> */}
                                {/* <img src="assets/images/geohr.png" height="60px" width="250px"/> */}
                                {/* <img src="assets/images/blog.png" height="80px" width="250px"/> */}
                                {/* <img src="assets/images/logo-login/sistelindo.png" height="150px" width="190px"/> */}
                                {/* <img src="assets/images/logo-login/panca_yellow.png" height="80px" width="310px"/> */}
                                {/* <img src="assets/images/logo-login/finlogo.png" height="80px" width="310px"/> */}
                                {/*<img src="assets/images/oslog_logo-vartindo.png" height="70px" width="300px"/>*/}
                                {/*<img src="assets/images/gmsi-logo.png" height="180px"/>*/}
                                {/* <img src="assets/images/logo-login/armytrack-top-login.png" height="150px"/> */}
                                {/* <img src="assets/images/logo-sisi.png" height="110px" width="200px"/> */}
                                {/* <img src="assets/images/kitos_login.png" height="40px" width="250px"/> */}
                                {/* <img src="assets/images/logo-login/quincus.png" height="80px" width="250px"/> */}
                                {/* <img src="assets/images/ntc_19.png" height="180px" width="250px"/> */}
                                {/* <img src="assets/images/logo-login/esway.png" height="40px" width="250px"/> */}
                            </div>
                            <br />
                            <div className="login-content">
                                <div className="login-header">
                                    <h1 style={{ textAlign: 'center' }}>Fleet Management System</h1>
                                    {/* <h2 style={{textAlign: 'center'}}>Cold Chain Management System</h2> */}

                                </div>

                                <div className="login-form">
                                    <form>
                                        <fieldset>
                                            <div className="form-group">

                                                <TextField
                                                    fullWidth
                                                    id="username"
                                                    label="Username"
                                                    type="text"
                                                    variant="outlined"
                                                    onChange={(event) => this.setState({ email: event.target.value })}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            // Do code here
                                                            this.props.showAuthLoader();
                                                            this.props.userSignIn({ email, password });
                                                            ev.preventDefault();
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">

                                                <TextField
                                                    fullWidth
                                                    id="password"
                                                    label="Password"
                                                    type="password"
                                                    variant="outlined"
                                                    onChange={(event) => this.setState({ password: event.target.value })}
                                                    onKeyPress={(ev) => {
                                                        if (ev.key === 'Enter') {
                                                            this.props.showAuthLoader();
                                                            this.props.userSignIn({ email, password });
                                                            ev.preventDefault();
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group d-flex justify-content-between align-items-center">
                                                <Button onClick={() => {
                                                    this.props.showAuthLoader();
                                                    this.props.userSignIn({ email, password });

                                                }} variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded">
                                                    <IntlMessages id="appModule.signIn" />
                                                </Button>

                                                {/* <div>
                                                    <Link to="/forgot-password"
                                                        title="Reset Password"><IntlMessages id="appModule.forgotPassword"/></Link>
                                                </div> */}
                                            </div>


                                        </fieldset>
                                    </form>
                                </div>
                            </div>


                            {/* <br />
                            <div className="d-flex justify-content-center align-items-center">
                                <h4 style={{ textAlign: 'center' }}>Powered by OSLOG</h4>
                            </div> */}

                        </div>

                    </div>
                </div>


                {
                    loader &&
                    <div className="loader-view">
                        <CircularProgress />
                    </div>
                }
                {showMessage && NotificationManager.error(alertMessage)}
                <NotificationContainer />
            </div>

            // <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">

            //     <div className="app-login-main-content">

            //         <div className="app-logo-content d-flex align-items-center justify-content-center">
            //             <img src="assets/images/newepoool.png" height="250px" width="200px"/>
            //         </div>

            //         <div className="app-login-content">
            //             <div className="app-login-header mb-4">
            //                 <h2 style={{textAlign: 'center'}}>Fleet Management System</h2>
            //             </div>

            //             <div className="app-login-form">
            //                 <form>
            //                     <fieldset>
            //                         <TextField
            //                             label="Username"
            //                             fullWidth
            //                             onChange={(event) => this.setState({email: event.target.value})}
            //                             // defaultValue={email}
            //                             className="mt-1 my-sm-1"
            //                             onKeyPress={(ev) => {
            //                                 if (ev.key === 'Enter') {
            //                                 this.props.showAuthLoader();
            //                                 this.props.userSignIn({email, password});
            //                                 ev.preventDefault();
            //                                 }
            //                             }}
            //                         />
            //                         <TextField
            //                             type="password"
            //                             label="Password"
            //                             fullWidth
            //                             onChange={(event) => this.setState({password: event.target.value})}
            //                             // defaultValue={password}
            //                             onKeyPress={(ev) => {
            //                                 if (ev.key === 'Enter') {
            //                                 // Do code here
            //                                 this.props.showAuthLoader();
            //                                 this.props.userSignIn({email, password});
            //                                 ev.preventDefault();
            //                                 }
            //                             }}
            //                             className="mt-1 my-sm-3"
            //                         />

            //                         <div className="mb-3 d-flex align-items-center justify-content-between">
            //                             <Button onClick={() => {
            //                                 this.props.showAuthLoader();
            //                                 this.props.userSignIn({email, password});
            //                             }} variant="raised" color="primary">
            //                                 <IntlMessages id="appModule.signIn"/>
            //                             </Button>
            //                         </div>


            //                     </fieldset>
            //                 </form>
            //             </div>
            //         </div>

            //     </div>
            //     {
            //         loader &&
            //         <div className="loader-view">
            //             <CircularProgress/>
            //         </div>
            //     }
            //     {showMessage && NotificationManager.error(alertMessage)}
            //     <NotificationContainer/>
            // </div>


        );
    }
}

const mapStateToProps = ({ auth }) => {
    const { loader, alertMessage, showMessage, authUser } = auth;
    return { loader, alertMessage, showMessage, authUser }
};

export default connect(mapStateToProps, {
    userSignIn,
    hideMessage,
    showAuthLoader,
    userFacebookSignIn,
    userGoogleSignIn,
    userGithubSignIn,
    userTwitterSignIn,
    reqAllUserManage,
})(SignIn);



// WEBPACK FOOTER //
// ./containers/SignIn.js